jQuery(document).ready(function() {
	// single product
	jQuery('#product-form select[name="id"]').change(function(){
		var qty = jQuery(this).find('option:selected').attr('data-qty');
		var	price = jQuery(this).find('option:selected').attr('data-price');
		jQuery('.product-details__price').text( price );
		var option = null;
		for (i = 1; i <= qty; i++) { 
			option += '<option value="'+i+'">'+i+'</option>';
		}
		jQuery('select[name="quantity"]').html( option );
	});

});

Shopify.onItemAdded = function(line_item) {
  // alert(line_item.title + ' was added to your shopping cart.');
  $.getJSON('/cart.js', function (cart, textStatus) {
    action_cart(cart);
  });

};

Shopify.onCartUpdate = function(cart) {
    action_cart(cart);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert( data.description );
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

function action_cart(cart){
	var new_cart = '';
    $.each(cart.items, function(index, cartItem) {
    	new_cart += '<div class="row dropdown-bag__body"><div class="small-12 medium-4 columns"><img src="'+Shopify.resizeImage(cartItem.image, 'small')+'"/></div><div class="small-12 medium-8 columns text-left"><h1 class="dropdown-bag__title">'+cartItem.title+'</h1><!--<p class="meta__type">Type</p>--><p class="meta__size">Size : '+cartItem.variant_title+'</p><p class="meta__qty">Qty : '+cartItem.quantity+'</p><p class="meta__price">'+Shopify.formatMoney(cartItem.line_price)+'</p><a href="#" onclick="Shopify.removeItem('+cartItem.id+'); return false" class="remove-link">REMOVE</a></div></div>';
    });
    
    $('#header-cart-list').html(new_cart);
    $(".header__detail__item__total").text(cart.item_count);
    $('#header-price').text( Shopify.formatMoney(cart.total_price) );
    if( $(".dropdown-bag").is(':hidden') ){
	    $(".bag__trigger").trigger('click');
	}
}
